export default __webpack_public_path__ + "static/media/coilsoftheserpent.5c8bbd27.png";